<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8.325" stroke="#0D7BC4" stroke-width="1.35"/>
    <path d="M9.10988 11.0918H8.78387C8.55427 11.0918 8.36768 11.2784 8.36768 11.508V11.677C8.36768
    11.9066 8.55427 12.0932 8.78387 12.0932H9.10988C9.33949 12.0932 9.52608 11.9066 9.52608 11.677V11.508C9.52608
    11.2777 9.33949 11.0918 9.10988 11.0918Z" fill="#0D7BC4"/>
    <path d="M6.80994 7.60748L7.41134 7.68239C7.6021 7.70598 7.78314 7.59638 7.85181 7.41672C7.93852 7.1899 8.05922
    7.01093 8.21391 6.88052C8.43311 6.69601 8.70571 6.60306 9.03173 6.60306C9.36954 6.60306 9.63868 6.69185 9.83846
    6.86873C10.0382 7.04631 10.1374 7.25857 10.1374 7.50759C10.1374 7.68656 10.0812 7.85026 9.96886 7.9987C9.89603
    8.09304 9.67198 8.29143 9.2981 8.59456C8.92352 8.89769 8.6745 9.17098 8.54964 9.41376C8.42201 9.6621 8.37762
    9.93747 8.36652 10.2136C8.35681 10.4501 8.54548 10.6471 8.78271 10.6471H9.12261C9.33903 10.6471 9.51799
    10.4813 9.53741 10.2663C9.55129 10.1116 9.57695 9.99437 9.61581 9.9146C9.681 9.77794 9.84956 9.59759
    10.1201 9.37285C10.6438 8.9393 10.9851 8.59664 11.1453 8.34414C11.3049 8.09235 11.3853 7.82529 11.3853
    7.54297C11.3853 7.03313 11.1682 6.58572 10.7333 6.20143C10.2991 5.81714 9.7136 5.625 8.97833 5.625C8.27912
    5.625 7.71517 5.81437 7.2851 6.1938C6.91885 6.51705 6.69619 6.89995 6.6178 7.34181C6.59352 7.47083 6.68161
    7.59152 6.80994 7.60748Z" fill="#0D7BC4"/>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconHelper'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconHelper.vue